import { GeneralFieldController } from "./general-field-controller";
import { Maybe } from "@graphql-tools/utils";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { useTranslation } from "react-i18next";

export class GeneralDropdownCustomAttributeFieldController extends GeneralFieldController {
	override useControlProps(): Maybe<FlexControlProps> | undefined {
		const { t } = useTranslation();

		const options = this.schema.attribute.customCondition?.options?.map((option) => ({
			label: t(option),
			value: option,
		}));

		return {
			controlType: "typeahead",
			options: options ?? [],
			property: "value",
			selectPropertyValue: true,
		};
	}
}
